import Component from '@glimmer/component'
import { service } from '@ember/service'
import { action } from '@ember/object'

type DistributiveOmit<T, K extends PropertyKey> = T extends unknown ? Omit<T, K> : never;

type SlotComponentArgs<T extends PageConfig> = {
  pageSettings: Prettify<DistributiveOmit<T, keyof BasePage>>
}

export default class SlotComponent<T extends PageConfig> extends Component<SlotComponentArgs<T>> {
  @service flowManager: FlowManager

  get allStepsValid() {
    return this.flowManager.allStepsValid
  }

  @action
  back() {
    this.flowManager.back()
  }

  @action
  forward() {
    this.flowManager.forward()
  }

  @action
  goToPage(pageType: PageType) {
    this.flowManager.goToPage(pageType)
  }
}
